"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AlertToast", {
    enumerable: true,
    get: function() {
        return AlertToast;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Alert = require("../Alert/Alert");
const _Toastconstants = require("./Toast.constants");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const AlertToast = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { status, remove, exitDirection, index, ...props } = param;
    (0, _react.useImperativeHandle)(ref, ()=>({
            remove
        }));
    const exitIndex = exitDirection === "top" ? index + 1 : index - 1;
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "d654296c7db596d1",
                [
                    _Toastconstants.TOAST_ANIMATION_DURATION_MS,
                    _Toastconstants.TOASTS_LIMIT + 1 - index,
                    status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"),
                    _Toastconstants.TOAST_ANIMATION_DURATION_MS,
                    status === "entered" ? 1 : 0
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_Alert.Alert, {
        ...props,
        className: "toast"
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "d654296c7db596d1",
        dynamic: [
            _Toastconstants.TOAST_ANIMATION_DURATION_MS,
            _Toastconstants.TOASTS_LIMIT + 1 - index,
            status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"),
            _Toastconstants.TOAST_ANIMATION_DURATION_MS,
            status === "entered" ? 1 : 0
        ]
    }, "div.__jsx-style-dynamic-selector{position:absolute;padding:0 .5rem 0 .5rem;bottom:0;left:0;right:0;margin:0 auto;-webkit-transition:".concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms all!important;-moz-transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms all!important;-o-transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms all!important;transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms all!important;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;z-index:").concat(_Toastconstants.TOASTS_LIMIT + 1 - index, ";-webkit-transform:translatey(").concat(status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"), ");-moz-transform:translatey(").concat(status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"), ");-ms-transform:translatey(").concat(status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"), ");-o-transform:translatey(").concat(status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"), ");transform:translatey(").concat(status === "entered" ? "calc(".concat(index * -100, "% - ").concat(index * 0.5, "rem)") : "calc(".concat(exitIndex * -100, "% - ").concat(exitIndex * 0.5, "rem)"), ")}div.__jsx-style-dynamic-selector .toast{-webkit-transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms opacity!important;-moz-transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms opacity!important;-o-transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms opacity!important;transition:").concat(_Toastconstants.TOAST_ANIMATION_DURATION_MS, "ms opacity!important;opacity:").concat(status === "entered" ? 1 : 0, ";pointer-events:all;margin-bottom:.5rem}")));
});
AlertToast.displayName = "Toast";

//# sourceMappingURL=AlertToast.js.map